<div #mapElement class="map-container">
    <a #mapLink [href]="link" target="_blank" [hidden]="true"></a>
    <div *ngIf="!noCard" class="custom-card">
        <div (click)="launchMap()">
            <div id="{{mapId}}"></div>
        </div>
    </div>
    <div *ngIf="noCard" id="{{mapId}}"></div>
</div>
